import classNames from 'classnames'
import { PropsWithChildren } from 'react'

import styles from './MobileCard.module.scss'

interface MobileCardProps extends PropsWithChildren {
  className?: string
  id?: string
  'data-tour-target'?: string
}

export const MobileCard: React.FC<MobileCardProps> = (props) => {
  const { id, children, className, 'data-tour-target': tourTarget } = props

  return (
    <div id={id} className={classNames(styles.mobileCard, className)} data-tour-target={tourTarget}>
      {children}
    </div>
  )
}

export const MobileCardList: React.FC<PropsWithChildren> = (props) => (
  <div className={styles.mobileCardList}>{props.children}</div>
)
